import type { FunctionComponent } from 'react'
import React from 'react'

import classNames from 'classnames'

import { CrossIcon } from '../../Icons/Navigational/Cross'
import styles from './CloseButton.module.scss'

export const CloseButton: FunctionComponent<Props> = ({ callback, className }) => {
  const handleCloseButtonKeyPress = (e: React.KeyboardEvent) => {
    if (e.key === 'Enter') {
      callback()
    }
  }

  const handleCloseButtonClick = () => {
    callback()
  }

  return (
    <button
      onClick={handleCloseButtonClick}
      onKeyPress={handleCloseButtonKeyPress}
      data-testid="closeButton"
      className={classNames(styles.closeButton, className)}
      aria-label="Close this modal"
    >
      <CrossIcon width={15} height={15} className={styles.crossIcon} />
    </button>
  )
}

type Props = { className?: string; callback: () => unknown }
